
<div class="modal fade" id="comment_modal" tabindex="-1" aria-labelledby="comment_modalLabel" aria-hidden="true">
  <div class="modal-dialog modal-fullscreen modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="hide_modal"></button>
      </div>
      <div class="modal-body">
      <div class="mb-4">
          <form @submit.prevent="post_comment">
          <textarea class="form-control mb-2" rows="2" placeholder="Add comment..." v-model="comment_text"></textarea>
          <div class="d-flex justify-content-end mt-2">

            <button class="btn btn-primary btn-sm text-xs rounded-3 shadow-sm">Post</button>
          </div>
          </form>
        </div>

  <!-- Comments Section -->
  <h6 class="mb-3">Comments <span class="badge bg-primary">{{comments.length}}</span></h6>
 <div v-for="comment in comments">
<div class="mb-4">
    <div class="d-flex">
      <i class='bx bxs-user-circle fs-1 me-2 text-secondary'></i>
      <div class="w-100">
        <div class="d-flex justify-content-between">
          <strong class="text-xs">{{comment.created_by_name}}</strong>
          <small class="text-muted"><span>{{ time_ago(comment.date_created) }}</span></small>
        </div>
        <p class="mb-1 text-xs">{{comment.comment_text}}</p>
        <div class="d-flex align-items-center">
           <button
          class="btn btn-sm btn-link text-decoration-none p-0"
          @click="reply_comment_id = (reply_comment_id === comment.id ? null : comment.id)"
        >
          <i class="bi bi-reply"></i> Reply ({{ comment.reply_count }})
        </button>
        </div>
        <form action="">
             <div class="d-flex align-items-center px-3 py-2 bg-light rounded-5 shadow-sm" v-if="reply_comment_id === comment.id">
              <input type="text" v-model="reply_text" @keyup.enter="reply_to_comment(comment.id)"
                    class="form-control form-control-sm text-xs border-0 bg-light shadow-none p-0 fw-500"
                    placeholder="Write your reply ..."/>
              <button class="btn p-0 ms-2" type="button" @click="reply_to_comment(comment.id)">
                <i class="bi bi-send-fill text-primary"></i>
              </button>
            </div>
          </form>
      </div>
    </div>


    <!-- Nested Reply -->
    <div class="d-flex mt-3 ms-5" v-for="reply in comment.replies">
      <i class='bx bxs-user-circle fs-1 me-2 text-secondary'></i>
      <div class="w-100">
        <div class="d-flex justify-content-between">
          <strong class="text-xs">{{reply.created_by_name}}</strong>
          <small class="text-muted">{{ time_ago(reply.date_created) }}</small>
        </div>
        <p class="mb-1 text-xs">{{reply.reply_text}} </p>
      </div>
    </div>
  </div>

  </div>
  </div>
  </div>
      </div>
    </div>

